import * as React from 'react';
import { AppContextProps } from 'src/_context/App';

type State = {
	text: string | undefined;
	showCookies: boolean;
};
type Props = { appContext: AppContextProps };
class Cookies extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			text: undefined,
			showCookies: false,
		};
	}
	componentDidMount() {
		const initialShowCookies = localStorage.getItem('showCookies');
		const {
			appContext: { app },
		} = this.props;
		const cookiesText = app && app.Config && app.Config.CookiesText;

		const cookies =
			(initialShowCookies === null || initialShowCookies === 'true') &&
			!!cookiesText;
		this.setState(() => ({ showCookies: cookies, text: cookiesText }));
	}

	componentDidUpdate() {
		const showCookies = localStorage.getItem('showCookies');
		const {
			appContext: { app },
		} = this.props;
		const cookiesText = app && app.Config && app.Config.CookiesText;

		const cookies =
			(showCookies === null || showCookies === 'true') && !!cookiesText;
		this.setState(() => ({ showCookies: cookies, text: cookiesText }));
	}

	render() {
		const { showCookies, text } = this.state;
		const handleClick = () => {
			localStorage.setItem('showCookies', 'false');
			this.setState(() => ({ showCookies: false }));
		};

		if (!showCookies || !text) {
			return null;
		}

		return (
			<div
				style={{
					position: 'fixed',
					top: '55%',
					left: '50%',
					width: '100%',
					maxWidth: '1290px',
					transform: 'translate(-50%, -50%)',

					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',

					margin: '0 auto',
					fontSize: '0.8rem',
					zIndex: 999,
					textAlign: 'center',
				}}
			>
				<div
					style={{
						width: '100%',
						maxWidth: '1290px',

						padding: '100px 20px',
						margin: '0 13%',
						backgroundColor: 'white',
					}}
				>
					<div dangerouslySetInnerHTML={{ __html: text }} />
					<button
						onClick={handleClick}
						style={{
							backgroundColor: 'transparent',
							border: 'none',
							margin: 0,
							padding: 0,
							fontFamily: 'inherit',
						}}
					>
						[ ok ]
					</button>
				</div>
			</div>
		);
	}
}
export default Cookies;



// WEBPACK FOOTER //
// ./src/Components/Cookies/Cookies.tsx